//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { API } from 'aws-amplify'
import userMixin from '~/mixins/user'
import forumApi from '~/utils/forumApi'
import Areas from '~/utils/areas'
import getMenusWithArea from '~/gql/getMenusWithArea'

export default {
  mixins: [userMixin],
  props: {
    variant: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      variantMenu: this.variant,
      notifications: [],
      userLinks: {
        signUp: null,
        joinCommunity: null,
      },
    }
  },
  async fetch() {
    if (this.$auth.user && this.$store.state.user?.forumId) {
      const { results } = await API.get(
        'forum',
        `${forumApi.MEMBERS}/${this.$store.state.user?.forumId}${forumApi.NOTIFICATIONS}`
      )
      this.notifications = results
    }

    const menu = await this.$graphcms.request(getMenusWithArea, {
      area: [Areas.USERLINKS],
      lang: [this.$i18n.locale, this.$i18n.defaultLocale],
    })
    const { menuItems } = menu.sectionMenus[0]

    this.userLinks.signUp = menuItems[0]

    // modern menu
    const menuModern = await this.$graphcms.request(getMenusWithArea, {
      area: [Areas.USERLINKS_MODERN],
      lang: [this.$i18n.locale],
    })
    this.userLinks.joinCommunity = menuModern.sectionMenus[0]
  },
  computed: {
    isDrawerMenuOpen() {
      return this.$store.state.global.drawer === 'menu-mobile-modern';
    },
  },
  watch: {
    '$i18n.locale'() {
      this.$fetch()
    },
  },
  methods: {
    showDrawer(name) {
      this.$store.commit('global/setDrawer', {
        drawer: name,
        layer: false,
      });
      document.body.classList.add('no-scroll');
    },
    close() {
      this.$store.commit('global/setDrawer', {
        drawer: null,
        layer: false,
      });
      document.body.classList.remove('no-scroll');
    },
    search() {
      this.$store.commit('global/setDialog', {
        dialog: 'search-bar',
        layer: true,
      })

      if (this.userBranch !== '') {
        // eslint-disable-next-line no-undef
        const currentPageURL = window.location.href
        // eslint-disable-next-line no-undef
        window._mtm = window._mtm || []
        // eslint-disable-next-line no-undef
        window._mtm.push({
          event: 'site-search-tracking',
          'event-category': 'site-search-tracking',
          'event-action': `CLICK_LINK_URL - ${currentPageURL}`,
        })
      }
    },
  },
}
